<template>
  <div class="flex-1 flex justify-start px-3">
    <div class="w-full max-w-lg">
      <h2 class="text-left text-2xl sm:text-3xl font-bold text-gray-800 mb-6">
        Enter the Details below
      </h2>

      <form class="lg:space-y-8 sm:space-y-20" @submit.prevent="submit">
        <div>
          <label class="block text-left text-lg font-semibold text-gray-800 mb-2">
            Name (First Counter)
          </label>
          <input
v-model="counter1" type="text" placeholder="Enter Full Name"
            class="bg-white w-full rounded-md border border-gray-300 px-4 py-2 text-gray-800 shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-600" />

          <p v-if="counter1Error" class="text-red-600 text-sm mt-1">
            {{ counter1Error }}
          </p>
        </div>

        <!-- SECOND COUNTER -->
        <div>
          <label class="block text-left text-lg font-semibold text-gray-800 mb-2">
            Name (Second Counter)
          </label>
          <input
v-model="counter2" type="text" placeholder="Enter Full Name"
            class="bg-white w-full rounded-md border border-gray-300 px-4 py-2 text-gray-800 shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-600" />
          <p v-if="counter2Error" class="text-red-600 text-sm mt-1">
            {{ counter2Error }}
          </p>
        </div>

        <!-- AREA -->
        <div>
          <label class="block text-left text-lg font-semibold text-gray-800 mb-2"> Area </label>
          <input
v-model="enteredArea" type="text" placeholder="Enter Area"
            class="bg-white w-full rounded-md border border-gray-300 px-4 py-2 text-gray-800 shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-600" />
          <p v-if="areaError" class="text-red-600 text-sm mt-1">
            {{ areaError }}
          </p>
        </div>

        <!-- DEPOT -->
        <div>
          <label class="block text-left text-lg font-semibold text-gray-800 mb-2"> Depot </label>


          <app-dropdown
:model-value="selectedDepot.name" align="right" label-key="name" value-key="name" size="large"
            :options="depots" @update:model-value="(value: string) => store.setSelectedDepot(value)">
            Select Depot
          </app-dropdown>

          <p v-if="depotError" class="text-red-600 text-sm mt-1">
            {{ depotError }}
          </p>
        </div>

        <div class="flex justify-between pt-3">
          <button
v-if="canUserFixStock()" type="button" class="w-40 py-2 rounded-md text-lg font-semibold transition bg-green-600 text-white"
            @click="navigateToController">
            Stock Controller
          </button>

          <button
type="submit"
            class="w-40 py-2 rounded-md text-lg font-semibold transition bg-blue-600 text-white disabled:bg-gray-300 disabled:text-gray-500"
            :disabled="hasSubmitted && !isFormValid">
            Start
          </button>
        </div>

        <!-- Combined error list -->
        <div v-if="hasSubmitted && validationErrors.length" class="text-red-700 text-sm mt-3">
          <ul class="list-disc ml-6">
            <li v-for="err in validationErrors" :key="err">
              {{ err }}
            </li>
          </ul>
        </div>
      </form>
    </div>
  </div>
</template>


<script setup lang="ts">
import useStockTake from '@/stores/stocktakestore'
import { useRouter } from 'vue-router'
import useUserStore from '@/stores/auth'
import { onMounted } from 'vue'

import { storeToRefs } from 'pinia'


const store = useStockTake()
const router = useRouter()
const userStore = useUserStore()


// expose state as refs for v-model
const {
  counter1,
  counter1Error,
  counter2,
  counter2Error,
  enteredArea,
  areaError,
  selectedDepot,
  depotError,
  depots,
  hasSubmitted,
  isFormValid,
  validationErrors,
} = storeToRefs(store)

const canUserFixStock = () => {
  return userStore.isAbleTo(['view-stock-controller'])
}

const navigateToController = () => {
  router.push('/stocktake-app/stockcontroller')
}




async function submit() {

  const ok = store.attemptSubmit()
  if (!ok) return

  store.startSession({
    counter1: counter1.value.trim(),
    counter2: counter2.value.trim(),
    area: enteredArea.value.trim(),
    depot: selectedDepot.value.name.trim()
  })

  await router.push(`/stocktake-app/stockitems/${selectedDepot.value.name.trim()}`)
}

onMounted(() => {
  store.loadDepots()
})
</script>
